










import CircleLoader from '@/components/CircleLoader.vue';
import Courses from '@/components/courses/Courses.vue';
import ScrollTop from '@/components/courses/ScrollTop.vue';
import Sidebar from '@/components/sidebar/Sidebar.vue';
import { Component, Vue } from 'vue-property-decorator';


@Component({
  components: { CircleLoader, Courses, Sidebar, ScrollTop }
})
export default class Dashboard extends Vue {
  get isLoading() {
    return this.$store.getters['app/isLoading'];
  }

  async created() {
    await this.$store.dispatch('courses/initCourses');
  }
}
